import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';


import {environment, MenuEnum} from '../../../environments/environment';
import * as _ from 'lodash';

@Component({
    selector: 'app-theproject-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, AfterViewInit {
    //adminUrl: string;
    //links = navigation;

    iicMenus = [
      {"routelink":['/demo/summary'],"title":"中心簡介"},
      {"routelink":['/demo/news'],"title":"最新消息"},
      {"routelink":['/demo/station'],"title":"進駐辦法"},
      {"routelink":['/pfev'],"title":"教師媒合"},
      {"routelink":['/demo/government'],"title":"政府資源"},
      {"routelink":['/demo/enviroment'],"title":"環境介紹"},
      {"routelink":['/demo/customer'],"title":"廠商櫥窗"},
      {"routelink":['/demo/partner'],"title":"策略夥伴/表單下載"},
      {"routelink":['/demo/email'],"title":"聯絡我們"},
      {"href":'http://ostar.nkust.edu.tw',"title":"O'STAR諮詢輔導"},
      {"href":'http://startup.nkust.edu.tw',"title":"創業新星選拔"},
    ];
  backendUrl;
  hideAdminLink = false;
  moreInfo:boolean;
  constructor(private router: Router) {
    this.hideAdminLink = environment.hideAdminLink;
    this.moreInfo = environment.moreInfo
    this.router.events.subscribe((val) => {
      $('#navbar-collapse-1').removeClass('show');
    });
  }
  

    ngOnInit() {
      this.filterMenu();
      this.backendUrl = environment.url + '/admin';
    }

    ngAfterViewInit() {

    }
    filterMenu(){
      switch (environment.menu){
        case MenuEnum.IIC:
          this.iicMenus = _.filter(this.iicMenus,(x)=>{ return x.title != '教師媒合'});
          break;
        case MenuEnum.PFEV:
          this.iicMenus = _.filter(this.iicMenus,(x)=>{ return x.title == '教師媒合'});
          break;
      }
      
  
    }
}
